import { Modal, message } from "antd";

export const ErrorAlert = (err) =>
  message.error(
    err?.response?.data?.message?.toLocaleUpperCase() || "An error occurred"
  );

export const SuccessAlert = (response) =>
  message.success(response?.data?.message?.toLocaleUpperCase() || "Success");

export const CustomSuccessAlert = (msg) => message.success(msg);

export const CustomErrorAlert = (msg) => message.error(msg);

export const ConfirmationDialogue = (msg, yes, no, callBack) =>
  Modal.confirm({
    title: "Confirm",
    content: msg,
    okText: yes,
    cancelText: no,
    onOk: callBack,
  });
